const courses = [
  {
    title: "Kubernetes Essentials",
    link: "https://www.educative.io/path/kubernetes-essentials",
    university: "Educative",
  },
  {
    title: "Highload Architect",
    link: "otus.ru",
    university: "OTUS",
  }, 
  {
    title: "Building Scalable Data Pipelines with Kafka",
    link: "https://www.educative.io",
    university: "Educative",
  },
  {
    title: "Distributed Systems for Practitioners",
    link: "https://www.educative.io",
    university: "Educative",
  },
  {
    title: "Introduction to Software Product Management",
    link: "https://www.coursera.org/account/accomplishments/certificate/6DJA5N5PHG8S",
    university: "Coursera",
  },
  {
    title: "Divide and Conquer, Sorting and Searching, and Randomized Algorithms",
    link: "https://www.coursera.org/account/accomplishments/certificate/RHRZ43A4VX75",
    university: "Stanford & Coursera",
  },
  {
    title: "Python for Data Science, AI & Development",
    link: "https://www.coursera.org/account/accomplishments/certificate/2RHMVQJBLW5S",
    university: "Coursera",
  }, 
];

export default courses;
